import LJAppUsageFilters, {
    LJAppUsageFilterNames,
    LJAppUsageFormSection,
    ljAppUsageFilterDefaults
} from "root/s360components/LJAppUsage/LJAppUsageFilters";
import {useForm, useWatch} from "react-hook-form";
import LJAppUsageManager from "root/s360components/LJAppUsage/LJAppUsageManager";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

const LJAppUsageContainer = ({}) =>
{
    const {control, register} = useForm({
        defaultValues: {
            ...ljAppUsageFilterDefaults()
        }
    });

    const [ leaId ] = useWatchDropdown( {control, name: LJAppUsageFormSection + '.' + LJAppUsageFilterNames.LEA} ) ;
    const [ userType ] = useWatchDropdown( {control, name: LJAppUsageFormSection + '.' + LJAppUsageFilterNames.USER_TYPE} ) ;

    const hideUnused = useWatch( {control, name: LJAppUsageFormSection + '.' + LJAppUsageFilterNames.HIDE_UNUSED} ) ;

    return (
        <div className='sims-admin-container'>
            <h2>Learning Journal App Usage Summary</h2>
            <p key='this-screen'>This screen shows Learning Journal app usage for each school in an LEA.</p>
            <p key='counts-only' style={{color: '#b77171'}}>Only aggregate counts are shown - no individual users are listed</p>
            <label>Please select an LEA and user type</label>
            <LJAppUsageFilters control={control} register={register} sectionName={LJAppUsageFormSection} key='LAUF'/>
            <LJAppUsageManager leaId={leaId} userType={userType} hideUnused={hideUnused === true} key='LAUM'/>
        </div>
    )
}

export default LJAppUsageContainer;
